import { render, staticRenderFns } from "./MaterialRaiseConfigForm.vue?vue&type=template&id=04be08f2&scoped=true"
import script from "./MaterialRaiseConfigForm.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialRaiseConfigForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MaterialRaiseConfigForm.vue?vue&type=style&index=0&id=04be08f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04be08f2",
  null
  
)

export default component.exports